import "./styles/_main.scss";
import "devextreme/ui/notify";
import "devextreme/localization";
import "devextreme-vue/file-uploader";
import "devextreme-vue/check-box";
import "devextreme-vue/color-box";
import "devextreme-vue/number-box";
import "devextreme-vue/select-box";
//import "devextreme-vue/data-grid";
//import "devextreme-vue/html-editor";
import { locale, loadMessages } from "devextreme/localization";
host.plugins.register({
    // #region Vars
    name: "288a.web.dx.core",
    // #endregion
    // #region Startup
    startup() {
        locale(navigator.language);
    },
    // #endregion
    // #region Boostrap
    boostrap(data) {
        // #region DevExpress
        if (data.translationsDx) {
            loadMessages(data.translationsDx);
        }
        // #endregion
    }
    // #endregion
});
